<template>
  <b-message type="is-info">
    <p>
      {{ $t("projet.doc.default-text") }}
    </p>
    <ul>
      <li v-for="link in links" :key="link.url">
        <a :href="$t(link.url)" target="doc"> {{ $t(link.text) }}</a>
      </li>
    </ul>
  </b-message>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { BMessage } from "buefy"

export class DocLink {
  url: string
  text: string

  constructor(url: string, text: string) {
    this.url = url
    this.text = text
  }
}

export default defineComponent({
  name: "DocumentationLinks",
  components: {
    BMessage,
  },
  props: {
    links: {
      type: Array as PropType<DocLink[]>,
      required: true,
    },
  },
})
</script>

<!-- Style -->
<style lang="scss" scoped>
@import "@/styles/variables";

.h3-title-view {
  color: $title-default-color;
  text-align: left;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
}
</style>
